module.exports = __webpack_public_path__ + "static/works-ontarget-3f0dd5f21e0f8f1f59958684ccf3e86c.jpg";